import script from "./galleryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./galleryView.vue?vue&type=script&setup=true&lang=ts"

import "./galleryView.vue?vue&type=style&index=0&id=c2f6fe22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2f6fe22"]])

export default __exports__